import { call, takeLatest, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import ProductService from 'shared/services/ProductsService';
import {
  getAllProducts,
  getProductsFail,
  setProductsData
} from './products.redux';

import { TAction, TPaginationRequest } from 'shared/types';
import { IProductVariation } from 'shared/interfaces/product-variation.interface';

function* getProducts({
  payload
}: TAction<TPaginationRequest & { affiliate: string }>) {
  try {
    const result: AxiosResponse<IProductVariation[]> = yield call(
      ProductService.getProducts,
      payload
    );
    yield put(setProductsData(result.data));
  } catch (error) {
    console.log('error', error);
    yield put(getProductsFail());
  }
}
function* ProductVariations() {
  yield takeLatest(getAllProducts.type, getProducts);
}

export default ProductVariations;
